<template>
    <div id="page-dashboard">
        <sidebar/>
                 

        <div class="dashboard-view">
            <dashboard-nav-bar>  <div>{{view}}</div>     </dashboard-nav-bar> 
            

        <!--<excel-viewer/>-->

            <template v-if="view == 'root'">
                <!-- <navbar /> -->
                <div class="dasboard-view-container">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus sit veniam quisquam molestias, consequuntur fuga adipisci reprehenderit exercitationem est alias quibusdam nam sequi autem officia quaerat vero? Sapiente, aliquam optio!
                </div>
            </template>


            <template v-if="view == 'listProjects'">
                <project-list/>
            </template>

            <template v-if="view == 'listContragents'">
                <company-list/>
            </template>

            <template v-if="view == 'listWorkers'">
                <company-list :listType="'worker'"/>
            </template>

            <template v-if="view == 'listClients'">
                <company-list :listType="'client'"/>
            </template>            




        </div>

    </div>
</template>



<script>
import sidebar from "@/components/dashboard/sidebar"
import navbar from "@/components/navbar"
import excelViewer from "@/components/excelViewer"
import DashboardNavBar from "@/components/dashboard/DashboardNavBar"
import ProjectList from "@/components/dashboard/ProjectList"
import CompanyList from "@/components/dashboard/CompanyList"

export default {
   name: 'dashboard-view',
   components: {sidebar, DashboardNavBar, navbar, ProjectList, CompanyList, excelViewer},
   data (){
        return {
            view: 'root',
            viewTitle: '',
            viewFilter: ''
        }
    },

    methods:{
        setView(module){
            this.view = module;
        }
    }

}
</script>

<style>
#page-dashboard{
    display: flex;
}


.dashboard-side-nav-wrapper{
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 6rem;
    width: 6rem;
    transition: all .2s ease-in-out;
}

.nav-expanded .dashboard-side-nav-wrapper{
    flex-basis: 220px;
    width: 220px;
}

.dashboard-view{
    display: flex;
    height: 100vh;
    transition: all .2s ease-in-out;
}
</style>
>